module.exports = __webpack_public_path__ + "img/process_2.c9b12194.png";